import React from 'react';
import { bool, shape, string } from 'prop-types';

const Service = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 5.90039C13 4.00043 14.3 2.39999 16 2V4.10059C15.4 4.4006 15 5.1008 15 5.80078C15.0002 6.90065 15.9001 7.80078 17 7.80078C18.0999 7.80078 18.9998 6.90065 19 5.80078C19 5.1008 18.6 4.4006 18 4.10059V2C19.7 2.49999 21 4.00044 21 5.90039C21 7.75545 19.7203 9.32651 18 9.77344V14.2275C19.7201 14.6745 20.9998 16.2448 21 18.0996C21 19.9996 19.7 21.5 18 22V19.9004C18.6 19.6004 19 18.9002 19 18.2002C19 17.1002 18.1 16.2002 17 16.2002C15.9 16.2002 15 17.1002 15 18.2002C15 18.9002 15.4 19.6004 16 19.9004V22C14.3 21.6 13 19.9996 13 18.0996C13.0002 16.2448 14.2799 14.6745 16 14.2275V9.77344C14.2797 9.32651 13 7.75545 13 5.90039Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M5 12V7H4L5 2L7 2L8 7H7V12H9V22H3L3 12H5ZM7 20V14H5V20H7Z" fill="currentColor" />
  </svg>
);

Service.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Service;
